<template>
  <div class="top-section">
    <div class="container-wrapper">
      <div class="top-section__container container-new">
        <div class="top-section__info">
          <h5
            class="txt--bold txt--36px txt--60px--l txt--height-44px txt--height-72px--l txt--color-04 mb-20 mb-24--l"
          >
            {{ $t('latinAmerica.topSection.title') }}
          </h5>
          <p
            class="txt--weight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-03 mb-0"
            v-html="$t('latinAmerica.topSection.desc')"
          />
        </div>

        <img
          src="@/assets/img/latin-america/top-section/country.svg"
          class="top-section__img"
          width="100%"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopSection',
}
</script>

<style lang="scss" scoped>
.top-section {
  &__container {
    display: grid;
    gap: toRem(20px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__info {
    display: flex;
    flex-direction: column;

    @include bp(m) {
      justify-content: center;
    }
  }

  &__img {
    max-width: toRem(350px);
    margin: 0 auto;

    @include bp(m) {
      // max-width: toRem(400px);
    }

    @include bp(l) {
      max-width: toRem(433px);
      margin-right: unset;
    }
  }
}
</style>
